import { z } from 'zod';

export const TargetPopulationRowSchema = z.object({
  IdParticipant: z.string().nonempty({ message: 'Patient ID is required' }),
  Email1: z.string().email({ message: 'Valid email is required' }),
});

export const TargetPopulationDataSchema = z
  .array(TargetPopulationRowSchema)
  .nonempty({
    message: 'Target population must have at least one participant',
  })
  .superRefine((data, ctx) => {
    const idToIndexes = new Map<string, number[]>();

    data.forEach((row, index) => {
      const arr = idToIndexes.get(row.IdParticipant) ?? [];
      arr.push(index);
      idToIndexes.set(row.IdParticipant, arr);
    });

    const duplicates = Array.from(idToIndexes.entries()).filter(
      ([_, idxs]) => idxs.length > 1,
    );

    if (duplicates.length > 0) {
      duplicates.forEach(([_, idxs]) => {
        idxs.forEach((i) => {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: [i, 'IdParticipant'],
            message: `Participant EMA id ${i} must be unique (found ${idxs.length} times)`,
          });
        });
      });
    }
  });

export type TargetPopulationData = z.infer<typeof TargetPopulationDataSchema>;

export const TargetPopulationSchema = z.object({
  id: z.string().uuid(),
  fileName: z.string().min(1),
  data: TargetPopulationDataSchema,
});

export type TargetPopulation = z.infer<typeof TargetPopulationSchema>;

export const UpsertTargetPopulationSchema = TargetPopulationSchema.partial({
  id: true,
});

export type UpsertTargetPopulation = z.infer<
  typeof UpsertTargetPopulationSchema
>;

export const CreateTargetPopulationSchema = TargetPopulationSchema.omit({
  id: true,
});

export type CreateTargetPopulation = z.infer<
  typeof CreateTargetPopulationSchema
>;
